import React, { FC } from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { useRef } from 'react'
import { getImage } from '../../../../app/utlis/imageConstants'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg'

interface HosIntranetIdeaProjectProps {
    hospitalIntranetData: any
}

// Create a separate component for each project item
const ProjectItem: FC<{ project: any; index: number }> = ({ project, index }) => {
    const ref = useRef(null)
    const isInView = useInView(ref, { once: false, amount: 0.3 })
     let img = getImage(project.image ?? "") ?? "";

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 50 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className='bg-darkGreyPrimary py-6 md:py-12 border-b-4 border-[#313131] last:border-0'
        >
            <div className={`flex flex-col group ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} px-4 md:px-8 lg:px-40 gap-6 lg:gap-10 justify-center`}>
                <motion.div
                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                    animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                    transition={{ duration: 0.5, delay: 0.4 }}
                    className={classNames('flex flex-col w-full lg:w-2/4 pl-0 lg:pl-6', `flex-${project.row}`)}
                >
                    <div className={classNames('font-semibold text-2xl md:text-3xl lg:text-4xl', `text-${project.textColor}`)} >{project.title}</div>
                    <div className={classNames('text-greyQuaternary text-base md:text-lg pt-1 pb-6 md:pb-10', `text-${project.text}`)}>{project.subtitle}</div>
                    <div className={`grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 justify-between`}>
                        {project.steps.map((step: any) => {
                            return (
                                <div className={`bg-blackDark p-4 md:p-6 rounded-xl font-bold text-lg md:text-xl relative overflow-hidden border border-[#292929] hover:border-${project.textColor}`}>{step.title}</div>
                            )
                        })}
                    </div>
                </motion.div>
                <motion.div
                    initial={{ opacity: 0, x: index % 2 === 0 ? 50 : -50 }}
                    animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: index % 2 === 0 ? 50 : -50 }}
                    transition={{ duration: 0.5, delay: 0.6 }}
                    className={`mt-6 lg:mt-0 bg-blackDark border-r-4 md:border-r-8 border-t-4 md:border-t-8 border-${project.textColor} w-full lg:w-2/5 h-64 md:h-auto`}
                >
                 <DynamicSVG size='w-full h-full'>{img}</DynamicSVG>
                </motion.div>
            </div>
        </motion.div>
    )
}

const HosIntranetIdeaProject: FC<HosIntranetIdeaProjectProps> = ({ hospitalIntranetData }) => {
    return (
        <div className='flex flex-col gap-8 md:gap-12 pt-6 md:pt-12 bg-darkGreyPrimary'>
            {hospitalIntranetData.HosIntraIdeaProjectsData.map((project: any, index: number) => (
                <ProjectItem key={index} project={project} index={index} />
            ))}
        </div>
    )
}

export default HosIntranetIdeaProject
